// removed by extract-text-webpack-plugin
module.exports = {"asterisk":"RequiredField__asterisk___NQK2a"};